export const TABLE_MODAL_DEFAULT_PAGINATION = {
  page: 1,
  pageSize: 20,
}

export const TABLE_MODAL_NOTIFICATION_ERROR_ID = 'loadError'

export const TABLE_MODAL_SKELETON_ROWS = 5

export const TABLE_MODAL_PAGINATION_PAGE_SIZE_KEY = 'page_size'

export const TABLE_MODAL_CONTEXT_FLOATING = 'modalProvider'
